__turbopack_context__.v({
  "locationSearchContainer": "index-module-scss-module__Rp5SIq__locationSearchContainer",
});
